/**
 * This is a convenience component for the user account info menu. This is a
 * menu that generally has profile related links, such as logout and a link
 * directly to the user's profile self-management.
 */
import React from 'react';
import MenuItemFC from './MenuItemFC';
import AppHeaderStyles from './AppHeader.module.css';

const MainNavMenu = ({ menuItems }) => (
  <nav className={AppHeaderStyles.mainNav}>
    {menuItems.map((menuItem) => (
      <MenuItemFC
        key={`menu-item-key-${menuItem.displayText}`}
        className=""
        labelClassName={AppHeaderStyles.mainNavItemLabel}
        linkClassName={AppHeaderStyles.mainNavItem}
        menuItem={menuItem}
        subMenuContainerClassName={AppHeaderStyles.mainNavSubmenu}
        subMenuItemClassName={AppHeaderStyles.mainNavSub}
        subMenuLinkClassName={AppHeaderStyles.mainNavItemSub}
      />
    ))}
  </nav>
);

export default MainNavMenu;
